//import React from "react";
import * as ReactDOM from 'react-dom/client';
import App from "./App"; // ts-loader and typescript modules needed!

import "../../i18n/i18n.config";
import i18next from "../../i18n/i18n.config";

//import "bootstrap_css"; 

let params = window.get_search_params();
window.Languages.language = window.get_language(params);


if (params.hasOwnProperty("n")) {
    window.SearchParams.scroll_name = params["n"];
}

//console.log("i18", i18next);
//console.log("params", params);

i18next.changeLanguage(window.Languages.language, (err) => {
    if (err) {
        console.log("something went wrong with language selection: " + window.Languages.language, err);
        return;
    }
});

const container = document.getElementById('lib');
const root = ReactDOM.createRoot(container);
document.addEventListener('DOMContentLoaded', function () {
    var toggle = document.querySelector('.tab-toggle');
    var tabs = document.getElementById('tab-nav');

    if (!toggle || !tabs) return;

    toggle.addEventListener('click', function () {
        var isOpen = tabs.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
});
root.render(<App />);